<template>
    <div class="bg-white">
        <Row type="form-row">
            <Column
                class="text-right"

                :xs-display="xsDisplay"
                :sm-display="smDisplay"
                :md-display="mdDisplay"
                :lg-display="lgDisplay"
                :xl-display="xlDisplay"

                :xs-size="xsSize"
                :sm-size="smSize"
                :md-size="mdSize"
                :lg-size="lgSize"
                :xl-size="xlSize"

            >
                <IconButton
                    v-b-toggle.collapse1
                    :text="buttonName"
                    :is-bg-white="isBgWhite"
                    icon="angle-down"
                />
            </Column>
        </Row>
        <RowColumn type="form-row">
            <b-collapse id="collapse1" class="">
                <slot/>
            </b-collapse>
        </RowColumn>
    </div>
</template>

<script>
import Row from "../components/html/Row";
import Column from "../components/html/Column";
import IconButton from "../components/IconButton";
import RowColumn from "../components/RowColumn";
import sizeClassesMixin from "../components/html/mixin/sizeClassesMixin";
import displayClassesMixin from "../components/html/mixin/displayClassesMixin";

export default {
    name: "CurrencyCollapse",
    props: {
        buttonName: {
            type: String,
            default: 'additional'
        },
        isBgWhite: {
            type: Boolean,
            default: false
        }
    },
    components: {RowColumn, IconButton, Column, Row},
    mixins: [sizeClassesMixin, displayClassesMixin],
}
</script>

<style scoped>

</style>
